module.exports = __webpack_public_path__ + "static/media/optimize.7d81337d.mp4";